import legalData from '@data/legal/legal.json';

const PrivacyPolicyPage = () => {
  return (
    <div className="container-custom max-w-4xl">
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          {legalData.privacyPolicy.title}
        </h1>
        <p className="text-sm text-gray-500">
          Last Updated: {legalData.privacyPolicy.lastUpdated}
        </p>
      </div>

      <div className="space-y-8">
        {legalData.privacyPolicy.content.map((section, index) => (
          <div key={index}>
            <h2 className="text-xl font-bold mb-3">{section.heading}</h2>
            <p className="text-gray-700">{section.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 pt-8 border-t border-gray-200">
        <h2 className="text-xl font-bold mb-4">Data Security</h2>
        <p className="text-gray-700 mb-4">
          We take data security seriously and implement appropriate technical and organizational measures to protect your personal information.
        </p>
        
        <h3 className="text-lg font-semibold mb-3">What We Don't Do</h3>
        <ul className="space-y-2 mb-4">
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-gray-700">We do not store detailed medical records long-term</span>
          </li>
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-gray-700">We do not sell your personal data to third parties</span>
          </li>
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-gray-700">We do not share your information for marketing purposes</span>
          </li>
          <li className="flex items-start">
            <svg className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-gray-700">We do not keep payment information on our servers</span>
          </li>
        </ul>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold mb-2">Medical Data Handling</h3>
          <p className="text-gray-700 text-sm">
            Your medical information is treated with the highest level of confidentiality. Medical records are forwarded directly to 
            healthcare providers or administrators via secure email and are not stored on our servers long-term.
          </p>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-gray-200">
        <h2 className="text-xl font-bold mb-4">Your Rights</h2>
        <p className="text-gray-700 mb-4">
          You have the right to access, correct, or delete your personal information. To exercise these rights, 
          please contact us with your request.
        </p>
        <a
          href="/"
          className="btn-primary inline-block"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
